// extracted by mini-css-extract-plugin
export default {"wrapper":"rvTol","text":"n3a2Z","icon":"Y6Xhr"};